const employeeTypes = [
    {
        name: "Employee",
        value: 1
    },
];

export default employeeTypes;